import P from '../../pages';
import { generateProfileElementObject, setProfileElementsFromState, changeState, toggleField } from '../../utilities';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import SelectGroup from './SelectGroup';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import Alert from './Alert';
import ButtonGroup from './ButtonGroup';
import ReactMarkdown from 'react-markdown';
import ProfileElementField from './ProfileElementField';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import CustomFormGroup from './CustomFormGroup';
import { validator, fieldsToValidate, pageValid, executeValidations, shouldValidateProfileElement, toggleValidations } from '../../validator';

class CulturalBackground extends React.Component {
  constructor(props) {
    super(props);
    let experience = setProfileElementsFromState(this.props.profileElements, '', 'service', 'experience')
    let validateExperience = shouldValidateProfileElement(this, 'experience')
    let experienceDetails = setProfileElementsFromState(this.props.profileElements, '', 'service', 'experience_details')
    let validateExperienceDetails = experience && validateExperience
    this.state = {
      ethnicity: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'lifestyle', 'ethnicity'),
      religion: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'lifestyle', 'religion'),
      experience: { val: experience, validationKey: validateExperience ? 'profile_elements_service_experience' : '' },
      experienceDetails: { val: experienceDetails, validationKey: validateExperienceDetails ? 'profile_elements_service_experience_details' : '' },
      firstLanguage: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'lifestyle', 'first_language'),
      secondLanguage: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'lifestyle', 'second_language'),
      familyMedicalConditions: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'lifestyle', 'family_medical_conditions'),
      religiousPreference: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'lifestyle', 'religious_preference')
    };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.changeState = this.changeState.bind(this);
    this.sensitiveDataInfo = this.sensitiveDataInfo.bind(this);
    this.linkRenderer = this.linkRenderer.bind(this);
  }

  componentWillMount() {
    executeValidations(this)
  }

  changeState = async (id, val) => {
    if (id == 'experience') {
      toggleValidations(this, val, 'experience', 'experienceDetails', 'profile_elements_service_experience_details')
    }
    changeState(this, id, val)
  }

  back(e) {
    this.props.onGoBack();
  }

  linkRenderer(props) {
    return <a href={props.href} target="_blank">{props.children}</a>
  }

  sensitiveDataInfo() {
    const content = this.props.content;
    if (content.territory_code == "irl") {
      return (
        <div className="alert alert-info" style={{ marginTop: '0px' }}>
          <i className="fa fa-lightbulb fa-2x pull-left" />
          <ReactMarkdown
            source={content.sensitive_info}
            renderers={{ link: this.linkRenderer }} />
        </div>
      )
    } else {
      return (null)
    }
  }

  submit(e) {
    let payload = {
      lifestyle: {
        ethnicity: this.state.ethnicity.val,
        first_language: this.state.firstLanguage.val,
        second_language: this.state.secondLanguage.val,
        family_medical_conditions: this.state.familyMedicalConditions.val,
        religious_preference: this.state.religiousPreference.val,
        religion: this.state.religion.val
      },
      service: {
        experience: this.state.experience.val,
        experience_details: this.state.experienceDetails.val
      }
    }
    this.props.onHostProfileSubmit(payload);
  }

  render() {
    const thisPage = P.CULTURAL_BACKGROUND_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page} />
        <form onSubmit={this.submit}>
          <FormHeader title={content.pages.cultural_background.title} />

          <ProfileElementField
            childComponent={
              <SelectGroup
                title={formatMessage(defaultMessages.clientHostPagesCulturalBackgroundLabelsEthnicity)}
                setId={'ethnicity'}
                placeholder={formatMessage(defaultMessages.clientCommonSelectsPrompt)}
                options={this.props.ethnicity_options}
                defaultValue={this.state.ethnicity.val}
                valid={this.state.ethnicity.valid}
                controlFunc={e => this.changeState(e.target.id, e.target.value)} />
            }
            elementName='ethnicity' />

          <ProfileElementField
            childComponent={
              <SelectGroup
                title={formatMessage(defaultMessages.clientHostPagesCulturalBackgroundLabelsFirstLanguage)}
                setId={'firstLanguage'}
                placeholder={formatMessage(defaultMessages.clientCommonSelectsPrompt)}
                options={this.props.language_options}
                defaultValue={this.state.firstLanguage.val}
                valid={this.state.firstLanguage.valid}
                controlFunc={e => this.changeState(e.target.id, e.target.value)} />
            }
            elementName='first_language' />

          <ProfileElementField
            childComponent={
              <SelectGroup
                title={formatMessage(defaultMessages.clientHostPagesCulturalBackgroundLabelsSecondLanguage)}
                setId={'secondLanguage'}
                placeholder={formatMessage(defaultMessages.clientCommonSelectsPrompt)}
                options={this.props.language_options}
                defaultValue={this.state.secondLanguage.val}
                valid={this.state.secondLanguage.valid}
                controlFunc={e => this.changeState(e.target.id, e.target.value)} />
            }
            elementName='second_language' />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.religion.valid}>
                <ControlLabel>{formatMessage(defaultMessages.clientHostPagesCulturalBackgroundLabelsReligion)}</ControlLabel>
                <FormControl
                  type="text"
                  id={'religion'}
                  componentClass="input"
                  placeholder=""
                  defaultValue={this.state.religion.val}
                  onChange={e => this.changeState(e.target.id, e.target.value)} />
              </CustomFormGroup>
            }
            elementName='religion' />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.religiousPreference.valid}>
                <ControlLabel>{formatMessage(defaultMessages.clientHostPagesCulturalBackgroundLabelsReligiousPreference)}</ControlLabel>
                <FormControl
                  type="text"
                  id={'religiousPreference'}
                  componentClass="input"
                  placeholder=""
                  defaultValue={this.state.religiousPreference.val}
                  onChange={e => this.changeState(e.target.id, e.target.value)} />
              </CustomFormGroup>
            }
            elementName='religious_preference' />

          <ProfileElementField
            childComponent={
              <div>
                <CheckboxOrRadioGroup
                  title={formatMessage(defaultMessages.clientHostPagesCulturalBackgroundLabelsExperience)}
                  setName={'experience'}
                  type={'radio'}
                  checkBoxStyle={'radio-inline'}
                  controlFunc={e => this.changeState('experience', e.target.value == 'true')}
                  options={[
                    [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                    [formatMessage(defaultMessages.clientCommonNegative), 'false']
                  ]}
                  selectedOptions={[String(this.state.experience.val)]}
                  valid={this.state.experience.valid} />
                {
                  this.state.experience.val &&
                  <CustomFormGroup valid={this.state.experienceDetails.valid}>
                    <FormControl
                      type="text"
                      id={'experienceDetails'}
                      componentClass="input"
                      style={{ width: '100%' }}
                      placeholder={formatMessage(defaultMessages.clientCommonDetails)}
                      defaultValue={this.state.experienceDetails.val}
                      onChange={e => this.changeState(e.target.id, e.target.value)} />
                  </CustomFormGroup>
                }
              </div>
            }
            elementName='experience' />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.familyMedicalConditions.valid}>
                <ControlLabel>{formatMessage(defaultMessages.clientHostPagesCulturalBackgroundLabelsFamilyMedicalConditions)}</ControlLabel>
                <FormControl
                  type="text"
                  id={'familyMedicalConditions'}
                  componentClass="textarea"
                  placeholder=""
                  defaultValue={this.state.familyMedicalConditions.val}
                  onChange={e => this.changeState(e.target.id, e.target.value)} />
              </CustomFormGroup>
            }
            elementName='family_medical_conditions' />


          <Alert alert={content.pages.cultural_background.info} />
          {this.sensitiveDataInfo()}

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />
        </form>
      </div>
    );
  }
}

CulturalBackground.propTypes = {
  onHostProfileSubmit: PropTypes.func,
  onSkipSubmit: PropTypes.func,
  onGoBack: PropTypes.func,
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object
};

export default injectIntl(CulturalBackground);
